/* RemixCoverPhoto.js */

import React, { useCallback } from 'react';
import { Row, Col, FormGroup, Label, Button } from 'reactstrap';
import { toast } from 'react-toastify';
import RemixHelper from '../../helpers/RemixHelper';
import Strings from '../../translations/Translations';

export default function RemixCoverPhoto({ photo, setPhoto }) {

  const setFile = useCallback(async (evt) => {
    const files = evt.target.files;

    try {
      const media = await RemixHelper.processItsForMediaGrid(files, 'file');
      if (setPhoto && media && media[0]) {
        setPhoto(media[0]);
      }
    } catch (err) {
      console.error(err);
      toast.error(Strings('error_while_processing_image'));
    }
  }, [setPhoto]);

  return (
    <Row>

      {typeof(photo) === 'undefined' && (
        <Col md={12} className='mb-3'>
          <FormGroup>
            <Label className='pb-label-1'>{Strings('song_file')}</Label>
            <input
              type='file'
              className='form-control'
              accept='image/*'
              onChange={setFile}
            />
          </FormGroup>
        </Col>
      )}

      {photo && (
        <>
          <Col sm={12} className='d-flex justify-content-center mb-2'>
            <img className='img-fluid cover-preview' src={photo.src} alt='' />
          </Col>
          <Col sm={12} className='d-flex justify-content-center'>
            <Button size='sm' color='danger' onClick={() => { setPhoto(); }}>{Strings('remove')}</Button>
          </Col>
        </>
      )}

    </Row>
  );
}
